import React from "react";
import styles from "../spinner/spinner.module.scss";

const Spinner = () => {
  return (
    <div className={styles.loadingIcon}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default Spinner;
